<template>
  <div>
<!--    <div v-for="organization in organizationData" :key="organization.id">
      {{organization.name}}
      {{organization.next_meetup}}
    </div>-->
    <widget v-for="organization in organizationData" :key="organization.id"
            :rand="organization.rand"
            :organization-name="organization.name ?? ''"
            :organization-description="organization.short_intro ?? ''"
            :icon-path="organization.icon_path ? organization.icon_path : 'https://edzil.la/img/site/trees-clouds-square.jpg'"

            :organization-local-url="'/organization/' + organization.id"
            :organization-url="organization.url"

            :next-session="organization._next_session"
            :is-session-in-progress="organization._session_in_progress"

            :meetup="organization._next_meetup"
            :is-meetup-in-progress="organization._meetup_in_progress"
    >
    </widget>
    <!--    <template v-for="organization in organizationData">
          <span class="inline-block relative h-16 w-16 rounded-md bg-gray-100 mr-6 mb-6">
            <img class="h-12 w-12 m-2" src="https://cdn.worldvectorlogo.com/logos/apple.svg" alt="Kiwi standing on oval">
            <span class="absolute top-0 right-0 block h-4 w-4 transform -translate-y-1/2 translate-x-1/2 rounded-full ring-2 ring-white bg-green-400"></span>
          </span>
        </template>-->
  </div>
</template>

<script>
import Widget from './Widget';
import {
  ChartBarIcon,
  CursorClickIcon,
  PhoneIcon,
  PlayIcon,
  RefreshIcon,
  ShieldCheckIcon,
  ViewGridIcon,
} from '@heroicons/vue/outline';
export default {
  components: {
    Widget,
    ChartBarIcon,
    CursorClickIcon,
    PhoneIcon,
    PlayIcon,
    RefreshIcon,
    ShieldCheckIcon,
    ViewGridIcon,
  },
  name: "OrganizationWidgets",
  created() {

    this.fetchItems();
    setInterval(function () {
      this.fetchItems();
    }.bind(this), 200000);


  },
  setup(props) {
    const Phone = PhoneIcon;

  },
  data() {
    return {
      interval: null,
      organizationData: {
        inProgress: [],
        imminent: [],
        next: []
      },
    }
  },
  methods: {
    fetchItems: function () {
      axios.get('/organizations/widgets.json')
          .then(response => (this.organizationData = response.data))
          .catch(response => (console.log('catch')));

    },
  }
}
</script>

<style scoped>
</style>